export default __webpack_public_path__ + "static/media/imgDetails.9635c620.png";